export const adjustSignalStart = (signalStart, mainGraphWidth, signalLength) => {
    return signalStart + mainGraphWidth > signalLength ? Math.max(0, signalLength - mainGraphWidth) : signalStart;
};
